export const UPDATE_PREMIO_UNICO             = 'UPDATE_PREMIO_UNICO';
export const UPDATE_CLASSE_PREMIO_POTENZIALE = 'UPDATE_CLASSE_PREMIO_POTENZIALE';
export const SALVA_DATI_PREMIO 				 = 'SALVA_DATI_PREMIO';
export const UPDATE_DATI_PREMIO_VALIDA       = 'UPDATE_DATI_PREMIO_VALIDA';
export const UPDATE_APPENDICE_COSTI          = 'UPDATE_APPENDICE_COSTI';
export const UPDATE_TARIFFA                  = 'UPDATE_TARIFFA';
